import cx from "classnames";
import { Maybe } from "graphql/jsutils/Maybe";
import { Hr_Runner } from "@/graphql/gql/graphql";
import { getRunnerPick, hasRaceStarted } from "@/utils/horseRacing";
import { filterEmpty } from "@/utils/index";
import { HorseInfo, OddsBtn, SilkNum } from "../tableCells";
import styles from "./raceInfo.module.scss";

interface RaceInfoTableRowProps {
  runners: Maybe<Maybe<Hr_Runner>[]> | undefined;
  numerator: Maybe<number>;
  denominator: Maybe<number>;
  trackDataSource: string;
  fdrLink: string;
  saddleColor: string | undefined;
  numberColor: string | undefined;
  trackName: Maybe<string> | undefined;
  raceNumber: Maybe<string> | number | undefined;
  postTime: Maybe<string> | undefined;
}

const RaceInfoTableRow = ({
  runners,
  numerator,
  denominator,
  trackDataSource,
  fdrLink,
  saddleColor,
  numberColor,
  trackName,
  raceNumber,
  postTime,
}: RaceInfoTableRowProps) => {
  const runner = filterEmpty(runners ?? [])[0];

  if (!runner || !getRunnerPick(runner, trackDataSource).number) return <></>;
  const pick = getRunnerPick(runner, trackDataSource);

  if (!pick.number) return <></>;
  return (
    <tr className={cx(styles.tableRow, runner.scratched && styles.scratched)}>
      <td className={styles.tableCol}>
        <SilkNum
          saddleColor={saddleColor}
          runner={runner}
          numberColor={numberColor}
        />
      </td>
      <td colSpan={5} className={cx(styles.tableCol, styles.middle)}>
        <HorseInfo
          saddleColor={saddleColor}
          runner={runner}
          numberColor={numberColor}
          pick={pick}
        />
      </td>
      <td className={styles.tableCol}>
        <OddsBtn
          numerator={numerator ?? undefined}
          denominator={denominator ?? undefined}
          runner={runner}
          fdrLink={fdrLink}
          raceNumber={raceNumber}
          trackName={trackName}
          disabled={hasRaceStarted(postTime)}
        />
      </td>
    </tr>
  );
};

export default RaceInfoTableRow;
